import React, { createContext, useContext, useState } from "react";

const PageTitleContext = createContext();

export const usePageTitleContext = () => {
  const context = useContext(PageTitleContext);
  if (!context) {
    throw new Error(
      "usePageTitleContext deve ser usado dentro de um PageTitleProvider"
    );
  }
  return context;
};

export const PageTitleProvider = ({ children }) => {
  const [pageTitle, setPageTitle] = useState("");

  const updatePageTitle = (title) => {
    setPageTitle(title);
    document.title = `Talent Management - ${title}`;
  };

  return (
    <PageTitleContext.Provider value={{ pageTitle, updatePageTitle }}>
      {children}
    </PageTitleContext.Provider>
  );
};
